import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { TextInput } from '@dbk/ui-forms'
import { createContainer } from '@dbk-legacy/muster/react'
import { H3 } from '@dbk/ui-text'
import Dropdown from '@dbk/ui-dropdowns'
import { CANADIAN_COUNTRY } from '../../../../constants';
import { PAYMENT_TYPE } from '../../constant';
import { isCanadianError } from '../../payment-destination/utils';
import { EBANKINGWEBUK, RM_REGION_UK } from '../../../../constants';
import envConfig from '../../../../../db-env-build';

class PymtAmtDetails extends PureComponent {

  formatCurrency = currency => {
    return (currency) ? `${currency.tech} - ${currency.ebLabelDesc}`:null
  }
  getJsonObject = currencyList => currencyList && currencyList.map(
    currency => ({
      label: this.formatCurrency(currency),
      value: this.formatCurrency(currency)
    })
  )

  handleCurrencySelect = tech => {
    // tech presents "USD" refer to /transactions/initializeTx currencyList:
    /* [
      {
        "currencyKey": 210,
        "currencyId": 2637002,
        "isoCode": "SG",
        "currencyName": "SGD",
        "ebLabelDesc": null,
        "branchCode": 4,
        "tech": "SGD"
      },
      ]
    */
    const { setAmount, setSelectedCurrency, curcyWhiteList, isPymtAddNewBenef, selectedBeneficiaryBank , paymentType} = this.props.payments;
    const { i18n: { messages } } = this.props;
    if(paymentType.includes(PAYMENT_TYPE.international) && tech.includes(CANADIAN_COUNTRY.currencyCode) && !selectedBeneficiaryBank.country.includes(CANADIAN_COUNTRY.english.toUpperCase()) ){
      if(!isPymtAddNewBenef){
        if(!(selectedBeneficiaryBank && selectedBeneficiaryBank.address1 && selectedBeneficiaryBank.address2 && selectedBeneficiaryBank.address3)){
          this.props.payments.setSelectedBeneficiaryBank(null);
          this.props.payments.setSelectedBeneficiaryDetail(null);
          this.props.payments.setErrorMsg(isCanadianError(messages['app.payment.beneficiary.canada.rule']));
        }
      }
      this.props.payments.setErrorMsg(isCanadianError(messages['app.payment.beneficiary.canada.rule']));
    }
    
    else{
      this.props.payments.setErrorMsg("");
    }
    setAmount('');
    setSelectedCurrency(curcyWhiteList.find(e => this.formatCurrency(e) === tech))
  }

  handleChangeText = data => {
    if (typeof data === 'object') {
      const {
        target: { value }
      } = data

      //validate value(amount) as per trade unit
      const {
        payments : {selectedCurrency :{tradeUnit}}
      } = this.props;
      const noOfDecimals=tradeUnit?(tradeUnit.split(".")[1]?tradeUnit.split(".")[1].length:0):2;
      const regex = noOfDecimals?new RegExp("^\\d+(\\.\\d{0,"+noOfDecimals+"}|)$"):/^\d+$/;

      if (regex.test(value) || value == "")
        this.props.payments.setAmount(value);
    } else {
        this.props.payments.setAmount(data)
    }
  }

  componentDidMount(){
    if(this.props.payments.paymentType.includes(PAYMENT_TYPE.international)){
      const { selectedCurrency } = this.props.payments;
      if(selectedCurrency && selectedCurrency.tech && !selectedCurrency.tech.includes(CANADIAN_COUNTRY.currencyCode)){
        this.props.payments.setErrorMsg("");
      }
    }
  }

  formatCurrencyInputLabel = val => {
    const label =val.split('-');
    return label[0];
  }

  render() {
    const {
      i18n: { messages },
      payments: { curcyWhiteList, amount, selectedCurrency, paymentType },
    } = this.props
    const currencies = this.getJsonObject(curcyWhiteList) || []
    return (
      <div>
        <H3 className='paymentHeading' tabIndex={0}>{messages['app.report.transactionHistory.amount']}</H3>
        <div className="amntDetails payment-filter-input" >
          <div aria-label={messages['app.payment.currencyDropdown']}>
          <Dropdown
            testID="dropdown_paymentAmount_paymentAmountDetails_test"
            defaultLabel={false}
            selected={this.formatCurrency(selectedCurrency)}
            onChange={this.handleCurrencySelect}
            options={currencies}
            disabled={paymentType.includes('sepa') }
            className="customDropDownHt paymentAmtDropDown"
            formatInputLabel={(val)=> this.formatCurrencyInputLabel(val)}
            tabIndex={0}
          />
          </div>
          <div className="detailsInputArea">
            <TextInput aria-label={messages['app.payment.enterAmount']} className="detailsInput"id="input_paymentAmount_paymentAmountDetails_test" style={{ marginLeft: 20 }} value={amount} onChange={this.handleChangeText} />
            </div>
        </div>
      </div>
    )
  }
}
PymtAmtDetails.propTypes = {
  payments: PropTypes.shape({
    paymentType: PropTypes.string.isRequired,
    setAmount: PropTypes.func.isRequired,
    setSelectedCurrency: PropTypes.func.isRequired,
  }).isRequired,
  changePage: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
}

export default createContainer({
  $queries: {
    i18n: {
      locale: true,
      messages: true,
    },
    payments: {
      curcyWhiteList: true,
      selectedCurrency: true,
      setSelectedCurrency: { $set: 'selectedCurrency' },
      amount: true,
      setAmount: { $set: 'amount' },
      paymentType: true,
      selectedBeneficiaryBank: true,
      isPymtAddNewBenef : true,
      setSelectedBeneficiaryBank: { $set: 'selectedBeneficiaryBank' },
      errorMsgs: true,
      setErrorMsg: { $set: 'errorMsgs'},
      setSelectedBeneficiaryDetail: { $set: 'selectedBeneficiaryDetail'}
    },
  },
})(PymtAmtDetails)
